/**
 * @description 自动巡检 autoInspection
 * @author xiehan
 * @date 2020/03/09
 */

import Logic from '../logic-base'
import ExportTable from '@/utils/exportTable'

const autoInspectionBiz = new Logic()

autoInspectionBiz.getConfig = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.autoInspection.getConfig,
    data: data
  })
}

autoInspectionBiz.deleteConfig = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.autoInspection.deleteConfig,
    data: data
  })
}

autoInspectionBiz.saveConfig = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.autoInspection.saveConfig,
    data: data
  })
}

autoInspectionBiz.updateConfig = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.autoInspection.updateConfig,
    data: data
  })
}

autoInspectionBiz.getResult = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.autoInspection.getResult,
    data: data
  })
}

autoInspectionBiz.getResource = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.autoInspection.getResource,
    data: data
  })
}

autoInspectionBiz.getItem = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.autoInspection.getItem,
    data: data
  })
}

/**
 * Created by xiehan on 2020/03/09.
 * 自动巡检
 * @param fields 表头信息{name: text,...}
 * @param time  时间需要转换的表头
 * @param staticDictionary 静态字典
 */
autoInspectionBiz.export = function (fields, search, time, staticDictionary, success, fail) {
  const exportTable = new ExportTable({
    requestData: this.REQUEST_OPT.autoInspection.getResult,
    fields: fields,
    search: search,
    time: time,
    staticDictionary: staticDictionary,
    isJson: 0
  })
  exportTable.send(success, fail)
}

export default autoInspectionBiz
